import React, { useState } from "react";
import classNames from "classnames";

const EventFeed: React.FC<JQI.EventFeedProps> = ({
  children,
  className,
  limit,
  showMore,
}) => {
  const classList = classNames({
    "article-feed": true,
    "flex": true,
    "flex-col": true,
    "justify-center": true,
    [`${className}`]: !!className,
  });
  const childCount = React.Children.count(children);
  const [count, setCount] = useState(limit || childCount);
  const childrenToShow = React.Children.toArray(children).slice(0, count);
  return (
    <div className={classList}>
      <ul className="event-feed__list mb-4">
        {
          React.Children.map(children, (child, i) => (
            <li className="event-feed__list-item" key={`event-feed-item-${i}`}>
              {child}
            </li>
          ))
        }
      </ul>
      {
        (!!showMore && childCount > count) &&
        <div className="py-3">
          <button type="button" className="button button--gray article-feed__show-more" onClick={() => setCount(childCount)}>Load More Events</button>
        </div>
      }
    </div>
  );
};

export default EventFeed;
